export default [
  "a breathtaking accomplishment",
  "a command performance",
  "a praiseworthy performance",
  "a superb accomplishment",
  "an incredible performance",
  "awe-inspiring work",
  "beautiful work",
  "bravo",
  "congrats",
  "congratulations",
  "epic",
  "excellent",
  "felicitations",
  "flawlessly executed",
  "good job",
  "good work",
  "great job",
  "great work",
  "hats off",
  "hip, hip, hurrah",
  "impressive",
  "keep it up",
  "keep up the good work",
  "kudos",
  "look at you go",
  "mad props",
  "make it so",
  "marvelous",
  "nailed it",
  "neatly done",
  "nicely done",
  "now you have it",
  "outstanding work",
  "props",
  "sensational work",
  "smashing",
  "splendiferously done",
  "stellar",
  "stupendous job",
  "super job",
  "super-duper job",
  "superb job",
  "superb",
  "terrific",
  "that was brilliant",
  "three cheers",
  "tiptop performance",
  "top-notch work",
  "tremendous",
  "well done",
  "well played",
  "wonderful job",
  "world-class work",
  "you did it",
  "you've outdone yourself",
  //
  "rockin",
  "wow"
];
//# sourceMappingURL=phrases.js.map
